import { NavLink, useNavigate } from 'react-router-dom';
import './Header.css';

export default function Header({goBack}) {

    const links = [
        { name: 'AFL', url: '/sport/afl' },
        { name: 'NRL', url: '/sport/nrl' },
        { name: 'NFL', url: '/sport/nfl' },
        { name: 'NBA', url: '/sport/nba' },
        { name: 'EPL', url: '/sport/english premier league' },
        { name: 'Bundesliga', url: '/sport/Bundesliga' },
        { name: 'LaLiga', url: '/sport/La Liga' },
        { name: 'Ligue1', url: '/sport/French Ligue 1' },
        { name: 'SerieA', url: '/sport/Italian Serie A' },
    ];
    let history = useNavigate();

    const handleGoBack = () => {
        history(-1);
    }

    return (
        <nav className="navbar">
            {!goBack ? (
                <ul>
                    {links.map((link) => (
                        <li key={link.name}>
                            <NavLink to={link.url}>{link.name}</NavLink>
                        </li>
                    ))}
                </ul>
            ) : <button className='goBackBtn' onClick={handleGoBack}>Go back</button>}
        </nav>
    )
}
